import { useEffect, useState } from "react";
import axios from "axios";
import { webUrlNode } from "../../../constants/appInfo";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import DropDownButtonUI from "../CreateWebsite/DesignElements/DropDownButtonUI";
import ToggleSmallUI from "../../UI/ToggleSmallUI";
import { replaceDripItemByContentPostId } from "./replaceDripItemByContentPostId";
import { insertDripItem } from "./insertDripItem";
export default function AddBatchContentPopup({
  currentItem,
  currentDripItem,contentDripArr,   // null = add, object = edit
  onClose,
 
  onAdded
}) {


  const isEdit = !!currentDripItem?.contentPostId;
 const [useExactDate, setUseExactDate] = useState(isEdit?currentDripItem?.isExactDate?currentDripItem?.isExactDate:false:true)
 const [useDayWiseDrip, setUseDayWiseDrip] = useState(isEdit?currentDripItem?.isHourWise?currentDripItem?.isHourWise:false:false)
  const domain = useSelector((state)=>state?.app?.app?.domain);
    const {batchId} = useParams();
  const [form, setForm] = useState({
    dripType: "BATCH_BASED",

    dripAfterDays: 10,
    dripAfterHours: 10,

    dripAtBatchOffsetDays: 10,
    dripAtDateTime: "",

    displayOrder: 0
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ---------------------------------------
     Prefill when editing
  --------------------------------------- */
  useEffect(() => {

   // edit mode
  if (currentDripItem) {
    setForm({
      dripType: currentDripItem.dripType || "BATCH_BASED",
      dripAfterDays: currentDripItem.dripAfterDays ?? 1,
      dripAfterHours: currentDripItem.dripAfterHours ?? 1,
      dripAtBatchOffsetDays:
        currentDripItem.dripAtBatchOffsetDays ?? 1,
      dripAtDateTime:
        currentDripItem.dripAtDateTime
          ? currentDripItem.dripAtDateTime.slice(0, 16)
          : "",
      displayOrder: currentDripItem.displayOrder ?? 0
    });

    return;
  }

  // add mode (reset form)
  if (currentItem) {
    setForm({
      dripType: "BATCH_BASED",
      dripAfterDays: 1,
      dripAfterHours: 1,
      dripAtBatchOffsetDays:1,
      dripAtDateTime: "",
      displayOrder: 0
    });
  }

  }, [currentDripItem, currentItem]);

  function setField(name, value) {
    setForm(p => ({ ...p, [name]: value }));
  }

  async function submit() {

    setError("");
    setLoading(true);

    try {

      const payload = {
        domain,
        dripType: form.dripType,
        displayOrder: Number(form.displayOrder || 0)
      };

      if (form.dripType === "ENROLLMENT_BASED") {

        payload.dripAfterDays = Number(form.dripAfterDays || 0);
        payload.dripAfterHours = Number(form.dripAfterHours || 0);

        payload.dripAtBatchOffsetDays = null;
        payload.dripAtDateTime = null;
      }

      if (form.dripType === "BATCH_BASED") {

        payload.dripAfterDays = null;
        payload.dripAfterHours = null;

        payload.dripAtBatchOffsetDays =
          form.dripAtBatchOffsetDays !== ""
            ? Number(form.dripAtBatchOffsetDays)
            : null;

        payload.dripAtDateTime =
          form.dripAtDateTime
            ? form.dripAtDateTime
            : null;
      }

      // ---------------------------
      // EDIT
      // ---------------------------
      if (isEdit) {

   axios
  .patch(
    `${webUrlNode}/api/batches/batch-content/${currentDripItem.id}`,
    {...payload,isHourWise:useDayWiseDrip,isExactDate:useExactDate}
  )
  .then((apiData) => {
   
    replaceDripItemByContentPostId(
      contentDripArr,
      apiData?.data?.item
    );
  })
  .catch((err) => {
    console.error("Update drip item failed", err);
  });
      } else {

        // ---------------------------
        // ADD
        // ---------------------------
       await axios.post(
          `${webUrlNode}/api/batches/${batchId}/content`,
          {
    ...payload,
    contentPostId: Number(currentItem?.ID),
    contentType: currentItem?.postType,isHourWise:useDayWiseDrip,isExactDate:useExactDate
  }
        ).then((apiData) => {
  
    
    insertDripItem(contentDripArr, apiData.data.item);
     
  })
  .catch((err) => {
    console.error("Update drip item failed", err);
  });;
        
      }
      onAdded && onAdded();
      onClose();

    } catch (e) {
      console.error(e);
      setError(isEdit ? "Failed to update drip" : "Failed to add drip");
    } finally {
      setLoading(false); 
    }
  }

  return (
    <div style={{padding:"10px"}} >

      <div >

        <h1 style={{ marginTop: 0 }}>
          {isEdit ? "Edit drip" : "Add drip"}
        </h1>

        {error && (
          <div style={{ color: "red", fontSize: 13, marginBottom: 8 }}>
            {error}
          </div>
        )}

        <div style={{ fontSize: "22px", marginBottom: 10,fontWeight:"900" }}>
         
         <b>{((currentDripItem?.postType || currentItem?.postType) || "")
    ? (currentDripItem?.postType || currentItem?.postType)
        .charAt(0).toUpperCase() +
      (currentDripItem?.postType || currentItem?.postType).slice(1)
    : ""}-
  {(currentDripItem?.Name || currentItem?.Name || "Selected item")}   
  
</b>
        </div>
 <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"-5px",padding:"10px"
    ,display:"flex",justifyContent:"space-between",flexWrap:"wrap"}}>
          <div style={{display:"flex",justifyContent:"space-between",gap:"20px",position:"relative"}}><h3>Drip type </h3>
            
            <DropDownButtonUI activeCard={""} icon={3} title={form.dripType} 
                 onClickSendObject={(value)=>{  
                                    if(value){ 
                                         setField("dripType",value)}}}
                  hasDropDown={true} 
                  dropDownObject={[{title:"Batch Based",value:"BATCH_BASED"},{title:"Enrollment Based",value:"ENROLLMENT_BASED"}
                    
               
                                                                                    ]} />  </div>  
        {/* <Field label="Drip type">
          <select
            value={form.dripType}
            onChange={e => setField("dripType", e.target.value)}
          >
            <option value="ENROLLMENT_BASED">
              Enrollment
            </option>
            <option value="BATCH_BASED">
              Scheduled
            </option>
          </select>
        </Field> */}
<div style={{display:"flex",justifyContent:"center",gap:"20px",position:"relative"}} >
    <div>
        {form.dripType === "ENROLLMENT_BASED" && (
          <> <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}>
            <h5 style={{}}>Use Hour Wise Drip ?  </h5>
              <div style={{marginTop:"15px"}} >
                <ToggleSmallUI state={useDayWiseDrip} toggleState={(state)=>{ 
                                               setUseDayWiseDrip( state);}} /></div>
                                                 </div>
           {!useDayWiseDrip? <Field label={`Unlock  ${((currentDripItem?.postType || currentItem?.postType) || "")
    ? (currentDripItem?.postType || currentItem?.postType)
        .charAt(0).toUpperCase() +
      (currentDripItem?.postType || currentItem?.postType).slice(1)
    : ""} after Enrollment days`}>
              <input className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} 
                type="number"
                value={form.dripAfterDays}
                onChange={e => setField("dripAfterDays", e.target.value)}
              />
            </Field>:

            <Field label={`Unlock  ${((currentDripItem?.postType || currentItem?.postType) || "")
    ? (currentDripItem?.postType || currentItem?.postType)
        .charAt(0).toUpperCase() +
      (currentDripItem?.postType || currentItem?.postType).slice(1)
    : ""} after Enrollment   hours`}>
              <input className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} 
                type="number"
                value={form.dripAfterHours}
                onChange={e => setField("dripAfterHours", e.target.value)}
              />
            </Field>}
          </>
        )}

        {form.dripType === "BATCH_BASED" && (
          <>
          <div  style={{display:"flex",justifyContent:"space-between",marginTop:"-10px"}}>
            <h5 style={{}}>Use exact date/time ?  </h5>
              <div style={{marginTop:"15px"}} >
                <ToggleSmallUI state={useExactDate} toggleState={(state)=>{ 
                                               setUseExactDate( state);}} /></div>
                                                 </div>
            {!useExactDate?<Field label={`Unlock  ${((currentDripItem?.postType || currentItem?.postType) || "")
    ? (currentDripItem?.postType || currentItem?.postType)
        .charAt(0).toUpperCase() +
      (currentDripItem?.postType || currentItem?.postType).slice(1)
    : ""} after batch start (days)`}>
              <input className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} 
                type="number"
                value={form.dripAtBatchOffsetDays}
                onChange={e =>
                  setField("dripAtBatchOffsetDays", e.target.value)
                }
              />
            </Field>:

            <Field label={`Unlock ${((currentDripItem?.postType || currentItem?.postType) || "")
    ? (currentDripItem?.postType || currentItem?.postType)
        .charAt(0).toUpperCase() +
      (currentDripItem?.postType || currentItem?.postType).slice(1)
    : ""} at exact date/time`}>
              <input className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} 
                type="datetime-local"
                value={form.dripAtDateTime}
                onChange={e =>
                  setField("dripAtDateTime", e.target.value)
                }
              />
            </Field>}
          </>
        )}

        {/* <Field label="Display order">
          <input className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} 
            type="number"
            value={form.displayOrder}
            onChange={e => setField("displayOrder", e.target.value)}
          />
        </Field> */}
        
        </div>
</div>
       

      </div>
      <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  <button    className="CreateCourseStepsOuterRightButtonBack" onClick={onClose} disabled={loading}>
            Cancel
          </button>

          <button className="CreateCourseStepsOuterRightButton" 
            onClick={submit}
            disabled={loading}
            style={{ marginLeft: 8 }}
          >
            {loading ? "Saving…" : (isEdit ? "Update" : "Add")}
          </button>
    
  </div>
       
    </div>
    </div>
  );
}

/* ---------------------------- */

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 10, fontSize: 13 }}>
      <div style={{ marginBottom: 4 ,fontSize:"22px",fontWeight:"900"}}>{label}</div>
      {children}
    </div>
  );
}

const backdropStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.35)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000
};

const modalStyle = {
  width: 380,
  maxWidth: "95%",
  background: "#fff",
  padding: 16,
  borderRadius: 8
};
